module.exports = __webpack_public_path__ + "img/Flag_of_Maldives.dd23d996.svg";